import React, { useState } from 'react';

import PropTypes from 'prop-types';

import CountryFlag from 'components/CountryFlag/CountryFlag';
import IconButton from 'components/IconButton';
import Personas from 'components/Personas/Personas';
import { useQueryGetCountries } from 'Customers/hooks/useCustomers';
import { useQueryGetUsers } from 'Users/hooks/useUsers';

import CustomerInfo from './CustomerInfo';
import styles from './Header.module.scss';
import AddCustomerModal from '../../Modal/AddCustomerModal/AddCustomerModal';
import { splitRepresentativeName } from '../../utility';
import AddAccountManagerModal from '../AddAccountManagerModal/AddAccountManagerModal';

const Header = ({ details }) => {
  const [addCustomerModal, setAddCustomerModal] = useState(false);
  const [addAccountManager, setAddAccountManager] = useState(false);
  const { data } = useQueryGetCountries();
  const countryDetails = data?.data?.items?.find((item) => item.alphaThreeCode === details.country) || [];
  const { firstName, lastName } = splitRepresentativeName(details?.representative ?? '');
  const selected = { ...details, workEmail: details?.contactEmail, lastName, firstName };
  const { data: Activeusers } = useQueryGetUsers({
    userStatus: 'true',
    currentPage: 1,
    perPage: 9999,
  });

  return (
    <div className='bg-light radius-8 p-3 my-4'>
      <div className='row'>
        <div className='col-5'>
          <div className='d-flex align-items-start ms-2 mt-2'>
            <div className={styles.logoBox}>
              <div className={styles.imgHolder}>
                {details?.logo ? (
                  <img src={details?.logo} alt='company-logo' />
                ) : (
                  <Personas name={details?.companyName} size={80} />
                )}
              </div>
              {countryDetails && (
                <div className={styles.flagBox}>
                  <div className='w-100 h-100 d-flex justify-content-center align-items-center'>
                    <CountryFlag data={countryDetails} />
                  </div>
                </div>
              )}
            </div>

            <div className='ms-4'>
              <div className='mb-4'>
                <p className={styles.name}>{details?.companyName}</p>
                <p className='label p-0'>COMPANY</p>
              </div>

              {details.actionList && details.actionList.length !== 0 && (
                <div className='d-flex align-items-center mb-2 gap-2'>
                  <i className='icon-notification font-size-20' style={{ color: '#ffa150' }} />
                  <p className='fs-14'> {details?.actionList.length} action required</p>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className='col-3 mt-2'>
          <CustomerInfo icon='icon-user-circle' type={'Representative Name'} name={details?.representative} />
          <CustomerInfo icon='icon-mail' type={'Work email'} name={details?.contactEmail} />
          <CustomerInfo icon='icon-call-phone' type={'Phone'} name={details?.phoneNumber} />
          <CustomerInfo icon='icon-people' type={'Job Title'} name={details?.jobTitle} />
          <CustomerInfo icon='icon-users' type={'Department'} name={details?.department} />
        </div>
        <div className='col-3 mt-2'>
          <CustomerInfo icon='icon-pin' type={'Address Line 1'} name={details?.billingInfo?.addressLine1} />
          <CustomerInfo icon='icon-housing' type={'State'} name={details?.billingInfo?.state} />
          <CustomerInfo icon='icon-city' type={'City'} name={details?.billingInfo?.city} />
          <CustomerInfo icon='icon-zip' type={'zip Code'} name={details?.billingInfo?.zip} />
          <CustomerInfo
            icon='icon-finance'
            type={'Tax Registration Number'}
            name={details?.billingInfo?.taxRegistrationNumber}
          />
        </div>

        <div className='col-1'>
          <div className='d-flex justify-content-end'>
            <IconButton
              icon='icon-pencil-create'
              size='sm'
              color='gray'
              onClick={() => {
                setAddCustomerModal(true);
              }}
            />
          </div>
        </div>
      </div>
      <div className='d-flex justify-content-start align-items-center mx-2 gap-2'>
        <div className='d-flex align-items-center mb-2 gap-2'>
          <p className='label p-0 me-1'> Account Manager : </p>
          <div
            className='cursor-pointer'
            onClick={() => {
              setAddAccountManager(true);
            }}
          >
            {details?.accountManager?.fullName ? (
              <div className='d-flex justify-content-start align-items-center gap-2'>
                <Personas name={details?.accountManager?.fullName} size={20} />
                <p className='fs-14 text-nowrap'>{details?.accountManager?.fullName}</p>
                <i className='icon-notification font-size-16 icon-chevron-bottom' />
              </div>
            ) : (
              <p className='fs-14 text-nowrap text-primary'> + Assign manager</p>
            )}
          </div>
        </div>
      </div>
      <AddCustomerModal
        isOpen={addCustomerModal}
        data={selected}
        onClose={() => {
          setAddCustomerModal(false);
        }}
      />
      <AddAccountManagerModal
        isOpen={addAccountManager}
        onClose={() => {
          setAddAccountManager(false);
        }}
        id={details?.id}
        users={Activeusers}
      />
    </div>
  );
};
Header.propTypes = {
  details: PropTypes.object.isRequired,
};

export default Header;
